import { Box, type SxProps, type Theme } from "@mui/material";
import { Title } from "@src/appV2/redesign/system/ui-components";

interface ShiftListDateHeaderProps {
  label: string;
  totalShiftsCount: number;
  sx?: SxProps<Theme>;
}

export function ShiftListDateHeader(props: ShiftListDateHeaderProps) {
  const { label, totalShiftsCount, sx } = props;

  return (
    <Box aria-label={label} sx={sx}>
      <Title
        semibold
        variant="h5"
        component="h2"
        sx={(theme) => ({
          zIndex: 1,
          color: totalShiftsCount === 0 ? theme.palette.text.disabled : theme.palette.text.primary,
        })}
      >
        {label}
      </Title>
    </Box>
  );
}
